import { Typography } from 'antd'
import styled from 'styled-components'

export const LogoStyled = styled(Typography.Title).attrs({
  level: 4,
})`
  display: inline-block;
  cursor: pointer;
`
